import {RoleModel, roleModelListFactory} from "./role.model";

export type PartnerAccountListResponse = {
  rows: PartnerAccountModel[];
  count: number;
};

export type SinglePartnerAccountResponse = {
  partner: PartnerAccountModel;
  roles: RoleModel[];
};

export interface PartnerAccountModel {
  id?: string;
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  organization?: string;
  userId?: string;
  roles?: string[];
  roleIds?: string[];
  registrationLink?: string;
}

export function partnerAccountModelFactory(json?: any): PartnerAccountModel {
  json = json || {};

  return {
    id: json.id || "",
    firstName: json.firstName || "",
    lastName: json.lastName || "",
    emailAddress: json.emailAddress || "",
    organization: json.organization || "",
    userId: json.userId || "",
    roles: Array.from(json.roles || []).map(role => `${role || ""}`).filter(it => !!it),
    roleIds: Array.from(json.roleIds || []).map(role => `${role || ""}`).filter(it => !!it),
    registrationLink: json.registrationLink || "",
  } as PartnerAccountModel;
}

export function partnerAccountModelListFactory(json?: any): PartnerAccountModel[] {
  return Array.from(json || []).map(row => partnerAccountModelFactory(row)) as PartnerAccountModel[];
}

export function partnerAccountListResponseFactory(json?: any): PartnerAccountListResponse {
  json = json || {};

  return {rows: partnerAccountModelListFactory(json["rows"]), count: +json["count"]};
}

export function singlePartnerAccountResponseFactory(json?: any): SinglePartnerAccountResponse {
  json = json || {};

  return {partner: partnerAccountModelFactory(json["partner"]), roles: roleModelListFactory(json["roles"])};
}
